var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"notes_holder js-temp-notes-holder"},[_c('td',{staticClass:"notes_content",attrs:{"colspan":"3"}},[_c('div',{staticClass:"content"},[_c('draft-note',{attrs:{"draft":_vm.draft}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }